import { ArrowDropDownOutlined } from '@mui/icons-material'
import {
  Button,
  ButtonGroup,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Typography,
} from '@mui/material'
import { BomItemType } from 'model/Project/BoMItemRow'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { WorkingStepType } from 'services/APIs/InternalAPI/internal-api.contracts'

type Props = {
  bomItemType: BomItemType
  activityType: WorkingStepType
  handleRemoveActivity: (activityType: WorkingStepType) => void
  handleRemoveActivityFromOtherRows: (activityType: WorkingStepType) => void
  removeLabel?: string
  removeOptionsLabel?: string
  removeFromOtherRowsLabel?: string
  removeFromOtherRowsHelperText?: string
}
export const ActivityRemoveButton = (props: Props) => {
  const { t } = useTranslation()
  const buttonGroupRef = useRef<HTMLDivElement>(null)
  const [open, setOpen] = useState(false)

  const supportsRemoveFromOtherRows =
    props.bomItemType === BomItemType.partType ||
    props.bomItemType === BomItemType.assemblyType

  return (
    <>
      <ButtonGroup
        ref={buttonGroupRef}
        variant="outlined"
        size="small"
        color="secondary"
      >
        <Button
          onClick={() => {
            setOpen(false)
            props.handleRemoveActivity(props.activityType)
          }}
        >
          {props.removeLabel ?? t('project:remove-working-step-tooltip')}
        </Button>
        {supportsRemoveFromOtherRows && (
          <Button
            size="small"
            aria-controls={open ? 'remove-working-step-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            aria-label={t(
              'project:remove-working-step-tooltip-options',
              props.removeOptionsLabel ?? 'select remove activity options',
            )}
            onClick={() => setOpen((o) => !o)}
          >
            <ArrowDropDownOutlined />
          </Button>
        )}
      </ButtonGroup>
      {supportsRemoveFromOtherRows && (
        <Popper
          sx={{ zIndex: 420000 }}
          open={open}
          anchorEl={buttonGroupRef.current}
          role={undefined}
          transition
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'left top' : 'left bottom',
              }}
            >
              <Paper>
                <MenuList id="remove-working-step-options">
                  <MenuItem
                    onClick={() => {
                      setOpen(false)
                      props.handleRemoveActivity(props.activityType)
                    }}
                  >
                    <Typography variant="body2">
                      {props.removeLabel ??
                        t('project:remove-working-step-tooltip')}
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setOpen(false)

                      props.handleRemoveActivityFromOtherRows(
                        props.activityType,
                      )
                    }}
                  >
                    <div>
                      <Typography variant="body2">
                        {props.removeFromOtherRowsLabel ??
                          t(
                            'project:remove-working-step-tooltip-from-other-rows',
                          )}
                      </Typography>
                      {props.removeFromOtherRowsHelperText && (
                        <Typography variant="caption" color="textSecondary">
                          {props.removeFromOtherRowsHelperText}
                        </Typography>
                      )}
                    </div>
                  </MenuItem>
                </MenuList>
              </Paper>
            </Grow>
          )}
        </Popper>
      )}
    </>
  )
}
